// Keep VISIBLE_PILLS_LIMIT in sync with SUBCATEGORY_PILLS_VISIBLE_LIMIT in
// app/controllers/public/api/v1/portals/categories_controller.rb
export const VISIBLE_PILLS_LIMIT = 5;
export const MODAL_PAGE_SIZE = 5;
export const SEARCH_DEBOUNCE_MS = 300;

export const TEST_IDS = {
  ROOT: 'subcategories-bar-root',
  ALL_PILL: 'subcategories-bar-all-pill',
  PILL_PREFIX: 'subcategories-bar-pill',
  VIEW_MORE_BUTTON: 'subcategories-bar-view-more-button',
  MODAL_ROOT: 'subcategories-modal-root',
  MODAL_CLOSE_BUTTON: 'subcategories-modal-close-button',
  MODAL_SEARCH_INPUT: 'subcategories-modal-search-input',
  MODAL_EMPTY_STATE: 'subcategories-modal-empty-state',
  MODAL_LOADING_STATE: 'subcategories-modal-loading-state',
  MODAL_ROW_PREFIX: 'subcategories-modal-row',
  MODAL_PAGINATION: 'subcategories-modal-pagination',
};
